import { render, staticRenderFns } from "./docTitle.vue?vue&type=template&id=1d38f543&scoped=true&"
import script from "./docTitle.vue?vue&type=script&lang=js&"
export * from "./docTitle.vue?vue&type=script&lang=js&"
import style0 from "./docTitle.vue?vue&type=style&index=0&id=1d38f543&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38f543",
  null
  
)

export default component.exports